import React from 'react';

const defaultIcons = {
  milestone: 'clipboard-list',
  travel: 'route',
  work: 'business-time',
  url: 'link',
  text: 'font',
  textarea: 'paragraph',
  checkbox: 'check'
};

export default ({ type, className, ...rest }) => {
  type = defaultIcons[type] ? defaultIcons[type] : type;
  return (
    <i className={`fas fa-${type} ${className ? className : ''}`} {...rest} />
  );
};
